import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, forwardRef, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { type ItemInfo, MENU_LABEL } from '@core/models/navigation-item.model';
import { FILTER_CONTAINER, FilterContainer } from '@core/models/utils';

import { MainNavMenuPanelComponent } from '../../../../layout/navigation/main-nav-menu-panel/main-nav-menu-panel.component';
import { NavigationItemsState } from '../../../../layout/navigation/state/navigation-items.state';
import { CompanyTypeBasedRoutePipe } from '../../../../layout/pipes/company-type-based-route.pipe';
import { CustomEventService } from '../../../../layout/repository/customEvent.service';

@Component({
  selector: 'ume-my-account-container',
  templateUrl: './my-account-container.component.html',
  styleUrls: ['./my-account-container.component.scss'],
  providers: [
    {
      provide: FILTER_CONTAINER,
      useExisting: forwardRef(() => MyAccountContainerComponent),
    },
  ],
  imports: [
    NgTemplateOutlet,
    RouterLinkActive,
    RouterLink,
    RouterOutlet,
    MatMenuModule,
    MatTabsModule,
    MatIcon,
    CompanyTypeBasedRoutePipe,
    MainNavMenuPanelComponent,
  ],
})
export class MyAccountContainerComponent extends FilterContainer {
  private readonly _router = inject(Router);
  private readonly _customEventService = inject(CustomEventService);

  private readonly _navigationItemsState = inject(NavigationItemsState);

  protected readonly navItems = computed(() =>
    this._navigationItemsState.sectionNavItems(MENU_LABEL.MY_ACCOUNT)
  );

  public handleClick(item: ItemInfo, event: MouseEvent): void {
    if (item.payment) {
      event.preventDefault();
      this._router.navigate(['/', 'plans', 'comparison']);
      return;
    }

    if (item.disabled) {
      event.preventDefault();
      this._router.navigate(['/', 'restricted-user-rights'], {
        queryParams: { disabledReason: item.disabledReason || null },
      });
      return;
    }

    if (item.requestUrl) {
      if (item.disabled || item.disabledReason) {
        event.preventDefault();
        this._router.navigate(['/', 'restricted-user-rights'], {
          queryParams: { disabledReason: item.disabledReason || null },
        });
        return;
      }

      this._customEventService.handleCustomEvent(item.requestUrl);
    }
  }
}
